export const DANISH_PHONE_PREFIX = '+45';
export const GERMAN_PHONE_PREFIX = '+49';
export const SWEDISH_PHONE_PREFIX = '+46';
export const FINNISH_PHONE_PREFIX = '+358';
export const PLACEHOLDER_GERMAN_MOBILE_NUMBER = '151 123 45 67';
export const PLACEHOLDER_SWEDISH_PHONE_NUMBER = '701 23 45 67';
export const PLACEHOLDER_DANISH_PHONE_NUMBER = '77 22 33 44';
export const PLACEHOLDER_FINNISH_PHONE_NUMBER = '40 123 1234';
export const KONTIST_PARTNER_KEY = 'kontist';

//Unleash feature flags
export const HELIX_LOGIN_ENABLED = 'HelixLoginEnabled';
